import { Center, Flex, Text, Link, Box, Button } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { VIEW_TRANSACTION } from "@constants/analytics";
import { trackEvent } from "@lib/utils";
import DefiTopOpportunity from "./components/DefiTopOpportunity";

import FooterButtons from "./components/FooterButtons";

interface DepositProps {
  modalTitle: string;
  modalSubTitle?: string;
  primaryBtnTxt?: string; // view transactions
  secondaryBtnTxt?: string; // close or cancel
  onSubmitPrimary?: () => void;
  onSubmitSecondary?: () => void;
  onTxView?: () => void;
  isAirdropVault: boolean;
  isStableVault?: boolean;
  isCryptaniumVault?: boolean;
  isStakeWithHgEth?: boolean;
}

const VaultDeposit = ({
  modalTitle,
  modalSubTitle,
  primaryBtnTxt,
  secondaryBtnTxt,
  isAirdropVault,
  isStableVault = false,
  onTxView,
  onSubmitPrimary,
  onSubmitSecondary,
  isCryptaniumVault = false,
  isStakeWithHgEth = false,
}: DepositProps) => {
  return (
    <Center
      textAlign="center"
      flexDir="column"
      w="100%"
      my="24px"
      mx={{ base: "0", md: "24px" }}
    >
      <BaseImage
        src="/assets/transactions/success.svg"
        width={80}
        height={80}
        alt="success"
      />
      <Text
        mt="1rem"
        fontSize={{
          base: "20px",
          md: "24px",
        }}
        lineHeight="28px"
      >
        {modalTitle}
      </Text>

      {modalSubTitle && (
        <Text
          fontSize="14px"
          lineHeight="21px"
          fontWeight={400}
          color="#4A6A6A"
          textAlign="center"
          maxW="288px"
          mt="4px"
        >
          {modalSubTitle}
        </Text>
      )}

      <Flex
        mt={isStakeWithHgEth ? "4px" : "0.5rem"}
        fontSize={isStakeWithHgEth ? "14px" : "12px"}
        fontWeight="400"
        textAlign="center"
        color={isStakeWithHgEth ? "#075A5A" : "textSecondary"}
        gap="4px"
      >
        <Link
          isExternal={!isStakeWithHgEth}
          borderBottom="1px dashed"
          _hover={{ textDecoration: "none" }}
          borderColor={isStakeWithHgEth ? "#075A5A" : "textSecondary"}
          onClick={() => {
            trackEvent(VIEW_TRANSACTION, {
              vault_type: isAirdropVault
                ? "airdrop"
                : isStableVault
                ? "stable"
                : isCryptaniumVault
                ? "cryptanium"
                : "yield",
            });
            onTxView?.();
          }}
        >
          View transaction
        </Link>
      </Flex>

      {isStakeWithHgEth && (
        <Button
          as="a"
          href="/gain/growth-vault/"
          variant="outline"
          borderColor="#CCE5E5"
          borderRadius="8px"
          color="#075A5A"
          fontSize="18px"
          fontWeight={500}
          lineHeight="23px"
          px="24px"
          py="12px"
          height="auto"
          mt="24px"
          bg="white"
          _hover={{ bg: "#F4F4F7" }}
        >
          Manage hgETH position
        </Button>
      )}

      {primaryBtnTxt && (
        <>
          <Text
            color="textSecondary"
            mt={{ base: "32px", md: "24px" }}
            fontWeight="400"
            fontSize="14px"
            lineHeight="20px"
          >
            Boost your agETH rewards with our DeFi partners.
          </Text>

          <DefiTopOpportunity type="vault" />
        </>
      )}

      {primaryBtnTxt || secondaryBtnTxt ? (
        <Box>
          <FooterButtons
            secondaryBtnTxt={secondaryBtnTxt}
            onSubmitSecondary={onSubmitSecondary}
            primaryBtnTxt={primaryBtnTxt}
            onSubmitPrimary={onSubmitPrimary}
          />
        </Box>
      ) : null}
    </Center>
  );
};

export default VaultDeposit;
